
function PropertySourcingController(){
	this.className			= "PropertySourcingController";
	this.view				= false; //"example";
	this.glob				= ["/property-sourcing**", "/property-sourcing?grid"];
    this.viewData			= {};
    this.log                = false;
}
PropertySourcingController.inheritsFrom( PageController );
PropertySourcingController.prototype.swap = function(onComplete){

    if (this.log) console.log(`%c[PropertySourcingController]`, 'background:cyan', `on`);

    this.$body				= $('body');
    this.baseController = Aviator.get("baseController")
    this.configTopicImageSymbolAnimation();


    this.imageController = this.baseController.getImageController();
    this.imageLoadedOrFailedDelegate =  (e) => {
        if(!e.image) return; //Early ones aren't ready with an image
        this.animationControllers.forEach(a => a.refresh());
    };
    this.imageController.addListener("refresh",this.imageLoadedOrFailedDelegate);
    this.imageController.addListener("failed",this.imageLoadedOrFailedDelegate);



    Preloader2.add("/assets/images/backgrounds/parque.svg").then(() => {
        //Add a delay to all it to render
        setTimeout(() => onComplete(), 10);
    });

    return false;
}
PropertySourcingController.prototype.on = function(onComplete){


    
    return true;    
}

PropertySourcingController.prototype.configTopicImageSymbolAnimation = function () {

    if (this.log) console.log(`%c[PropertySourcingController]`, 'background:cyan', `configTopicImageSymbolAnimation`);

    this.animationControllers = [];

    const topicImageSymbolList = document.querySelectorAll('.topic-image-symbol');
    topicImageSymbolList.forEach((topicImageSymbol, index) => {
        const containerSelector = `#topic-image-symbol-${index}`;

        const startX = (index%2==0) ? 8 : -8;
        const topicSymbols = [
            {
                selector: `${containerSelector} .topic-symbol`,
                start: {
                    x: startX,
                    y: 0
                },
                end: {
                    x: 0,
                    y: 0
                },
                duration: 1,
            },
        ]


        var animationController = new AnimationController({
            containerSelector: containerSelector,
            items: topicSymbols,
            triggerStart: 'top bottom',
            triggerEnd: 'top 30%',
            showMarkers: false
        });

        this.animationControllers.push(animationController);
    })
   
    
}